import { createAuthClient } from "better-auth/client";

export const authClient = createAuthClient({
  baseURL: `${window.location.origin}/api/auth/better`,
});

// Stable identifier used in cache keys
export const projectRef = "yalana";
